import api from '@/api/auditLog'

const state = {
}

const actions = {
  getAuditLogList (context, params) {
    return api.getAuditLogList(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
